// Shared pre-login card chrome for the S1 auth frames this agent owns
// (04 invited, 05 callback-working, 06 callback-failed) — Figma's
// "Shell/AuthShell — Narrow" component (instanced on 33:1419, 33:1447,
// 33:1464). No drawn Figma component exists for it in `ui/` or `shell/`
// (neither owns a cross-screen auth chrome), so it is a small local build
// per this wave's "missing primitive -> build the smallest local thing"
// rule. screens-auth-a's three S1 frames instance the same Figma component
// and necessarily built (or will build) their own copy under
// `screens/signin/` — see this agent's progress notes for the `polish`
// handoff to collapse the two.
//
// Deliberately NOT wrapped in `AppShell`: these are pre-login frames with
// no sidebar/topbar (CLAUDE.md §Design file, PRD 18 Rule 5).

import "../../tokens/paper.css";
import "../../ui/ui.css";
import "./invite.css";
import type { ReactNode } from "react";

export type AuthShellProps = {
  children: ReactNode;
};

/** Cream page, centered white card, the "• MAISIGHT" wordmark. */
export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="maisight-invite-page" data-chassis="paper">
      <div className="maisight-invite-card">
        <div className="maisight-invite-brand">
          <span className="maisight-invite-brand-dot" aria-hidden="true" />
          <span className="type-label">MAISIGHT</span>
        </div>
        <div className="maisight-invite-slot">{children}</div>
      </div>
    </div>
  );
}

/**
 * Primitive/Spinner (Figma 9:17) — "indeterminate progress arc". Not ported
 * to `ui/` by Wave 1 (its handoff notes list Toggle and Toast as the only
 * undrawn primitives, but no Spinner shipped either — see this agent's
 * progress notes). Built here, the smallest local thing: a single rotating
 * arc, no dependency, bound to `--accent-fill` per the FILL-not-INK rule
 * (a stroke color is a fill use, not text).
 */
export function AuthSpinner() {
  return (
    <div
      className="maisight-invite-spinner"
      role="status"
      aria-label="Loading"
    />
  );
}
